<ng-container *ngIf="cs.vm$ | async as vm">
  <div [content]="banner" editable-area></div>

  <dgx-components-grid-section
    [theme]="'background-alternative'"
    [themeFlush]="true"
  >
    <dgx-components-grid-container>
      <dgx-components-card [spacing]="5" class="order-confirmation__container">
        <dgx-components-grid-row>
          <dgx-components-grid-column class="order-confirmation__header">
            <h1 class="order-confirmation__title">
              {{ vm.cmsData.pageTitle }}
            </h1>
            <p
              *ngIf="vm.cmsData.pageSubtitle"
              class="order-confirmation__subtitle"
            >
              {{ vm.cmsData.pageSubtitle }}
            </p>
          </dgx-components-grid-column>
        </dgx-components-grid-row>

        <dgx-components-grid-row>
          <dgx-components-grid-column [md]="6" [xs]="12">
            <checkout-protection-confirmation-panel
              *ngFor="let quote of vm.completedQuotes"
              [border]="false"
              [promotionFirstPaymentTitle]="vm.promotionFirstPaymentTitle"
              [quoteDetails]="quote"
              [rounded]="'lg'"
              [variant]="'neutral'"
              class="order-confirmation__protection-confirmation-panel"
            />
          </dgx-components-grid-column>

          <dgx-components-grid-column [md]="6" [xs]="12">
            <checkout-customer-details
              [border]="false"
              [rounded]="'lg'"
              [variant]="'neutral'"
            />
          </dgx-components-grid-column>
        </dgx-components-grid-row>
      </dgx-components-card>
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div>
</ng-container>
